module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "centre-column"
  }, [_c('h2', [_vm._v("Forgot Password")]), _vm._v(" "), (_vm.success) ? _c('div', [_c('p', [_vm._v("\n        Your request was successful.  Please check your email, and click the link in the email to reset your password.\n      ")])]) : _c('div', [_c('p', [_vm._v("\n        An email will be sent to your email address containing a link that can be used to reset your password.\n      ")]), _vm._v(" "), _c('form', {
    staticClass: "form-signin"
  }, [_c('div', {
    staticClass: "form-group",
    class: _vm.validateEmail ? '' : 'has-error'
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "placeholder": "Email address",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-primary btn-block",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error"
  }, [_vm._v("There was a problem making the password reset request.  Please double check your email address, and if the problem continues, contact Wedge Networks support.")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2486863d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PasswordForgot.vue
// module id = 487
// module chunks = 2